import { Link, useNavigate, useParams } from "react-router-dom";
import { inventoryApi } from "../api";
import { InventoryItemForm } from "../components/InventoryItemForm";
import { InventoryPageHeader } from "../components/InventoryPageHeader";
import { InventoryError, InventoryLoading } from "../components/InventoryState";
import { useAsyncData, useMutation } from "../hooks";
import type { InventoryItem, InventoryItemUpdateRequest } from "../types";

export default function InventoryItemEditPage() {
  const id = Number(useParams().id);
  const navigate = useNavigate();
  const { data, loading, error } = useAsyncData(() => inventoryApi.getItem(id), [id]);
  const update = useMutation<InventoryItemUpdateRequest, InventoryItem>(
    (payload) => inventoryApi.updateItem(id, payload),
  );

  if (loading) return <InventoryLoading label="Loading item..." />;
  if (error) return <InventoryError message={error} />;
  if (!data) return <InventoryError message="Inventory item not found." />;

  return (
    <div className="space-y-5">
      <InventoryPageHeader
        title="Edit Inventory Item"
        description={data.code}
        actions={
          <Link to={`/inventory/items/${id}`} className="rounded-xl border px-4 py-2 text-sm font-semibold">
            ← Back to Item
          </Link>
        }
      />
      {update.error && <InventoryError message={update.error} />}
      <InventoryItemForm
        initial={data}
        submitting={update.loading}
        onSubmit={async (payload) => {
          await update.mutate(payload);
          navigate(`/inventory/items/${id}`);
        }}
      />
    </div>
  );
}
